import { QuestionOptionsService } from 'data/services';
import { QuestionOptionsServiceInterface } from 'domain/services';
import { makeRemoteCreateQuestionOption } from 'main/factories/usecases/evaluation-criteria/question-options/create-question-option-factory';
import { makeRemoteDeleteQuestionOption } from 'main/factories/usecases/evaluation-criteria/question-options/delete-question-option-factory';
import { makeRemoteGetQuestionOptionById } from 'main/factories/usecases/evaluation-criteria/question-options/get-question-option-by-id-factory';
import { makeRemoteReorderQuestionOptions } from 'main/factories/usecases/evaluation-criteria/question-options/reorder-question-option-factory';
import { makeRemoteUpdateQuestionOption } from 'main/factories/usecases/evaluation-criteria/question-options/update-question-option-factory';

export const makeQuestionOptionsService =
  (): QuestionOptionsServiceInterface => {
    return new QuestionOptionsService({
      reorderQuestionOptions: makeRemoteReorderQuestionOptions(),
      createQuestionOption: makeRemoteCreateQuestionOption(),
      updateQuestionOption: makeRemoteUpdateQuestionOption(),
      getQuestionOptionById: makeRemoteGetQuestionOptionById(),
      deleteQuestionOption: makeRemoteDeleteQuestionOption(),
    });
  };
